<template>
  <div class="w-table-wrap" style="max-height: 800px;">
    <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @validate="onValidate">   
      <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'CAJ PERKHIDMATAN AI'" >
        <template #title>
          CAJ PERKHIDMATAN BSE
          <w-flex justify-end class="mt2">
            <w-button @click="isMinimizedCajAi = !isMinimizedCajAi">
              <template v-if="isMinimizedCajAi">
                <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
              </template>
              <template v-else>
                <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
              </template>
            </w-button>
          </w-flex>
        </template>         
        <div v-show="!isMinimizedCajAi">
          <figure class="table-aims">
            <figure class="table">
              <table class="w-table">
                <tbody>
                  <tr class="row_data">
                    <td width="1px"><b>1.</b></td>
                    <td colspan="2"><strong>Konsultasi / Perkhidmatan (RM)<i aria-hidden="true" style=" color: red;">*</i></strong></td>
                    <td>:</td>
                    <td colspan="2">
                      <div v-if="datas.lkp_status_id==32 || datas.lkp_status_id==34">
                        <w-radios
                          class="mr2"
                          :items="ya_tidak"
                          v-model="datas.konsutasi_pemeriksaan_ya_tidak"
                          @input="jumlahCajPerluBayar"
                          inline
                        >
                        </w-radios>
                      </div>
                      <div v-else>
                        <w-tag
                          class="mr4"
                          bg-color="primary"
                          round>
                          <template v-if="datas.konsutasi_pemeriksaan_ya_tidak==1">Berbayar</template><template v-else>Subsidi</template>
                        </w-tag>
                      </div>
                    </td>
                    <td> 
                      <div v-if="datas.lkp_status_id==32 || datas.lkp_status_id==34">
                        <z-money 
                          style="margin:5px;" 
                          label="" 
                          class="mt4" 
                          v-model:originalValue="datas.konsutasi" 
                          @input="jumlahCajPerluBayar" 
                          outline
                        />
                      </div>
                      <div v-else><strong>RM</strong>
                        {{$zutil.formatDecimal(datas.konsutasi)}}
                      </div>
                    </td>
                  </tr>
                  <tr class="row_data">
                    <td width="1px"><b>2.</b></td>
                    <td colspan="2"><strong>Caj Pemeriksaan BSE (RM)<i aria-hidden="true" style=" color: red;">*</i></strong></td>
                    <td>:</td>
                    <td colspan="2">
                      <div v-if="datas.lkp_status_id==32 || datas.lkp_status_id==34">
                        <w-radios
                          class="mr2"
                          :items="ya_tidak"
                          v-model="datas.bayar_pemeriksaan_pd"
                          @input="jumlahCajPerluBayar"
                          inline
                        >
                        </w-radios>
                      </div>
                      <div v-else>
                        <w-tag
                          class="mr4"
                          bg-color="primary"
                          round>
                          <template v-if="datas.bayar_pemeriksaan_pd==1">Berbayar</template><template v-else>Subsidi</template>
                        </w-tag>
                      </div>
                    </td>
                    <td>
                      <div v-if="datas.lkp_status_id==32 || datas.lkp_status_id==34">
                        <z-money 
                          style="margin:5px;" 
                          label="" 
                          class="mt4" 
                          v-model:originalValue="datas.caj_pemeriksaan_pd" 
                          @input="jumlahCajPerluBayar" 
                          outline
                        />
                      </div>
                      <div v-else><strong>RM</strong>
                        {{$zutil.formatDecimal(datas.caj_pemeriksaan_pd)}}
                      </div>
                    </td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr class="row_data">
                    <td><b>3.</b></td>
                    <td colspan="2"><strong>Caj Perjalanan (RM)<i aria-hidden="true" style=" color: red;">*</i></strong></td>
                    <td>:</td>
                    <td colspan="2">
                      <div v-if="datas.lkp_status_id==32 || datas.lkp_status_id==34">
                        <w-radios
                          class="mr2"
                          :items="ya_tidak"
                          v-model="datas.bayar_pengangkutan"
                          @input="jumlahCajPerluBayar"
                          inline
                        >
                        </w-radios>
                      </div>
                      <div v-else>
                        <w-tag
                          class="mr4"
                          bg-color="primary"
                          round>
                          <template v-if="datas.bayar_pengangkutan==1">Berbayar</template><template v-else>Subsidi</template>
                        </w-tag>
                      </div>
                    </td>
                    <td>
                      <div v-if="datas.lkp_status_id==32 || datas.lkp_status_id==34">
                        <z-money 
                          style="margin:5px;" 
                          label="" 
                          class="mt4" 
                          v-model:originalValue="datas.pengangkutan" 
                          @input="jumlahCajPerluBayar" 
                          outline
                        />
                      </div>
                      <div v-else><strong>RM</strong>
                        {{$zutil.formatDecimal(datas.pengangkutan)}}
                      </div> 
                    </td>
                  </tr>
                  <tr class="row_data">
                    <td><b>4.</b></td>
                    <td colspan="2"><strong>Caj Lain-Lain (Jika Ada)(RM)</strong></td>
                    <td>:</td>
                    <td colspan="2">
                      <div v-if="datas.lkp_status_id==32 || datas.lkp_status_id==34">
                        <w-radios
                          class="mr2"
                          :items="ya_tidak"
                          v-model="datas.bayar_caj_lain"
                          @input="jumlahCajPerluBayar"
                          inline
                        >
                        </w-radios>
                      </div>
                      <div v-else>
                        <w-tag
                          class="mr4"
                          bg-color="primary"
                          round>
                          <template v-if="datas.bayar_caj_lain==1">Berbayar</template><template v-else>Subsidi</template>
                        </w-tag>
                      </div>
                    </td>
                    <td >
                      <div v-if="datas.lkp_status_id==32 || datas.lkp_status_id==34">
                        <z-money 
                          style="margin:5px;" 
                          label="" 
                          class="mt4" 
                          v-model:originalValue="datas.caj_lain_pemeriksaan" 
                          @input="jumlahCajPerluBayar" 
                          outline
                        />
                      </div>
                      <div v-else><strong>RM</strong>
                        {{$zutil.formatDecimal(datas.caj_lain_pemeriksaan)}}
                      </div> 
                    </td>
                  </tr>
                  <tr class="row_data">
                    <td>&nbsp;</td>
                    <td colspan="2"><strong>Nyatakan</strong></td>
                    <td>:</td>
                    <td>
                      <template v-if="datas.lkp_status_id==32 || datas.lkp_status_id==34">
                        <z-input 
                          style="margin:5px;" 
                          label="" 
                          class="mt4" 
                          v-model="datas.nyatakan_pemeriksaan" 
                          @input="jumlahCajPerluBayar" 
                          placeholder="Sila Masukan.." 
                          outline
                        />
                      </template>
                      <template v-else>
                        <template v-if="datas.nyatakan_pemeriksaan==null">-</template>
                        <template v-else>{{datas.nyatakan_pemeriksaan}}</template>
                      </template> 
                    </td>
                  </tr>
                  
                  <tr>
                    <td colspan="3">&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td colspan="3"><strong>Jumlah Caj Keseluruhan</strong></td>
                    <td>:</td>
                    <td colspan="2" align="left"><strong>RM</strong> {{$zutil.formatDecimal(datas.keseluruhan)}}</td>
                  </tr>
                  <tr>
                    <td colspan="3"><strong>Jumlah Caj Subsidi </strong></td>
                    <td>:</td>
                    <td colspan="2" align="left"><strong>RM</strong> {{$zutil.formatDecimal(datas.subsidi)}}</td>
                  </tr>
                  <tr>
                    <td colspan="3"><strong>Jumlah Caj Yang Perlu Dibayar</strong></td>
                    <td>:</td>
                    <td colspan="2" align="left"><strong>RM</strong> {{$zutil.formatDecimal(datas.perlu_bayar)}}</td>
                  </tr>
                </tbody>
              </table>
            </figure>
          </figure>
        </div>
      </w-card>
      
      &nbsp;
      <w-flex justify-end v-if="(datas.lkp_status_id==34) && $zutil.anyRole(['4'])">
        <w-tooltip md top color="white" bg-color="black">
          <template #activator="{ on }">
            <w-button :loading="loading" v-on="on" @click="simpanData">
              SIMPAN
            </w-button>
          </template>
          SIMPAN
        </w-tooltip>
        
        <w-tooltip md top color="white" bg-color="black">
          <template #activator="{ on }">
            <w-button class="ml1" bg-color="success" v-on="on" @click="validateSebelumHantar" :disabled="loading" :loading="loading">
              HANTAR
            </w-button>
          </template>
          HANTAR
        </w-tooltip>
      </w-flex>
      &nbsp;
    </w-form>   
  </div>
</template>

<script>
export default {
  name: "PemilikBse",
  props:{
    d_data: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.semakan.bse-aiman',
      form : {},
      datas : this.d_data,
      lkp_berahi : [],
      loading:false,
      isMinimizedCajAi:false,
      ternakan_list:[],
      list_stock:[],
      ya_tidak:[
        {value: 1, label: "Berbayar"},
        {value: 2, label: "Subsidi"},
      ],
      validators: {
        requiredRadio: (value) => {
          if (value === null || value === undefined || value === '') {
            return "Sila pilih Berbayar atau Subsidi";
          }
          return true;
        },
        requiredNumber: (value) => {
          if (value === null || value === undefined || value === '') {
            return "Medan ini wajib diisi";
          }
          const numValue = Number(value);
          if (isNaN(numValue)) {
            return "Medan ini wajib diisi dengan nombor";
          }
          return true;
        },
      },
    }
  },
  methods:{
    jumlahCajPerluBayar() {
      const konsutasi = Number(this.datas.konsutasi) || 0;
      const caj_pemeriksaan_pd = Number(this.datas.caj_pemeriksaan_pd) || 0;
      const pengangkutan = Number(this.datas.pengangkutan) || 0;
      const caj_lain_pemeriksaan = Number(this.datas.caj_lain_pemeriksaan) || 0;

      let subsidi = 0;
      let perlu_bayar = 0;
      
      if (this.datas.konsutasi_pemeriksaan_ya_tidak == 2) {
        subsidi += konsutasi;
      } else if (this.datas.konsutasi_pemeriksaan_ya_tidak == 1) {
        perlu_bayar += konsutasi;
      }

      if (this.datas.bayar_pemeriksaan_pd == 2) {
        subsidi += caj_pemeriksaan_pd;
      } else if (this.datas.bayar_pemeriksaan_pd == 1) {
        perlu_bayar += caj_pemeriksaan_pd;
      }

      if (this.datas.bayar_pengangkutan == 2) {
        subsidi += pengangkutan;
      } else if (this.datas.bayar_pengangkutan == 1) {
        perlu_bayar += pengangkutan;
      }

      if (this.datas.bayar_caj_lain == 2) {
        subsidi += caj_lain_pemeriksaan;
      } else if (this.datas.bayar_caj_lain == 1) {
        perlu_bayar += caj_lain_pemeriksaan;
      }

      const keseluruhan = perlu_bayar + subsidi;

      this.datas.keseluruhan = keseluruhan;
      this.datas.subsidi = subsidi;
      this.datas.perlu_bayar = perlu_bayar;
    },

    simpanData() {
      if(this.loading) return;
      
      this.loading = true;
      this.datas.hantar = 2; // 2 untuk simpan
      this.datas.caj_perkhidmatan = 1;
      
      this.submitData();
    },

      validateSebelumHantar() {
        if(this.loading) return;

        // Manual validation untuk medan wajib
        const errors = [];
        
        // Check radio buttons SAHAJA - mesti dipilih
        if (this.datas.konsutasi_pemeriksaan_ya_tidak === null || 
            this.datas.konsutasi_pemeriksaan_ya_tidak === undefined || 
            this.datas.konsutasi_pemeriksaan_ya_tidak === '') {
          errors.push("Sila pilih Berbayar atau Subsidi untuk Konsultasi / Perkhidmatan");
        }
        
        if (this.datas.bayar_pemeriksaan_pd === null || 
            this.datas.bayar_pemeriksaan_pd === undefined || 
            this.datas.bayar_pemeriksaan_pd === '') {
          errors.push("Sila pilih Berbayar atau Subsidi untuk Caj Pemeriksaan BSE");
        }
        
        if (this.datas.bayar_pengangkutan === null || 
            this.datas.bayar_pengangkutan === undefined || 
            this.datas.bayar_pengangkutan === '') {
          errors.push("Sila pilih Berbayar atau Subsidi untuk Caj Perjalanan");
        }


        if (errors.length > 0) {
          this.$zutil.notify(errors[0], false);
          return;
        }

        
        this.loading = true;
        this.datas.hantar = 1; // 1 untuk hantar
        this.datas.caj_perkhidmatan = 1;
        
        this.$swal({
          title: 'Anda Pasti?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            this.submitData();
          } else {
            this.loading = false;
          }
        });
      },

    
    submitData() {
      if (this.datas.id > 0) {
        this.$zcomm.update(this.resourceurl + '.update', this.datas.id, this.datas)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit();
            }
            
            if (this.datas.hantar == 1) {
              this.$zutil.notify("Berjaya dihantar", true);
              this.$inertia.visit(window.route('art.semakan.index'));
            } else {
              this.$zutil.notify("Berjaya disimpan", true);
              this.$inertia.visit(window.route('art.semakan.bse', this.datas.id) + '?tab=2');
            }
          })
          .catch(err => {
            this.loading = false;
            console.error(err);
          });
      } else {
        this.loading = false;
      }
    }
  },
  
  mounted() {
    this.jumlahCajPerluBayar();
  }
}
</script>  

<style>
.table-aims td{
  padding: 7px;
}
</style>